import { Component } from 'vue';
import SliceViewer from '@/src/components/SliceViewer.vue';
import VolumeViewer from '@/src/components/VolumeViewer.vue';
import ObliqueSliceViewer from '@/src/components/ObliqueSliceViewer.vue';
import Slice4MOViewer from '@/src/components/Slice4MOViewer.vue';
import MultiObliqueSliceViewer from '@/src/components/MultiObliqueSliceViewer.vue';
import MOSliceAndSimuViewer from '@/src/components/MOSliceAndSimuViewer.vue';

export const ViewTypeToComponent: Record<string, Component> = {
  '2D': SliceViewer,
  '2D-4MO': Slice4MOViewer,
  Oblique: ObliqueSliceViewer,
  '3D': VolumeViewer,
  Oblique3D: MultiObliqueSliceViewer,
  Oblique3DAndSimu: MOSliceAndSimuViewer,
};
